window.searchMatchCount = (function () {
  const MAX_PAGES = 20;
  const cache = {};

  function fetchPage(searchUrl, page) {
    const url = new URL(searchUrl, window.location.origin);
    url.searchParams.set('view', 'match_count');
    url.searchParams.set('page', page);

    return fetch(url.toString()).then((response) => {
      if (!response.ok) throw new Error(response.status);
      return response.json();
    });
  }

  return function (searchUrl) {
    if (cache[searchUrl]) return cache[searchUrl];

    cache[searchUrl] = fetchPage(searchUrl, 1)
      .then((firstPage) => {
        if (!firstPage.filtered || firstPage.pages <= 1) return firstPage.count;

        const lastPage = Math.min(firstPage.pages, MAX_PAGES);
        const requests = [];
        for (let page = 2; page <= lastPage; page++) {
          requests.push(fetchPage(searchUrl, page));
        }

        return Promise.all(requests).then((pages) =>
          pages.reduce((total, page) => total + page.count, firstPage.count)
        );
      })
      .catch((error) => {
        delete cache[searchUrl];
        throw error;
      });

    return cache[searchUrl];
  };
})();
